export const DEFAULT_OPTIONS: YMaps.IPolygonOptions = {
  fillColor: 'rgba(35, 133, 222, 0.1)',
  strokeColor: '#2385de',
  // Делаем полигон прозрачным для событий карты
  interactivityModel: 'default#transparent',
  strokeWidth: 3,
};
